import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children", "component", "render"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { deprecateComponent } from "@jutro/platform";
import { useAuth } from "./useAuth";
var secureRoutePropTypes = {
  children: PropTypes.func,
  component: PropTypes.elementType,
  render: PropTypes.func
};
export var SecureRouteInternal = function (_ref) {
  var children = _ref.children,
    Component = _ref.component,
    render = _ref.render,
    props = _objectWithoutProperties(_ref, _excluded),
    auth = useAuth();
  return !auth || auth.isAuthenticated || auth.isPending || auth.error || auth.login(), React.createElement(Route, props, function (routeProps) {
    return children ? children(_objectSpread(_objectSpread({}, routeProps), {}, {
      auth: auth
    })) : Component ? auth ? (null == auth ? void 0 : auth.isAuthenticated) && React.createElement(Component, routeProps) : React.createElement(Component, routeProps) : render ? render(_objectSpread(_objectSpread({}, routeProps), {}, {
      auth: auth
    })) : null;
  });
};
SecureRouteInternal.propTypes = secureRoutePropTypes, SecureRouteInternal.displayName = "SecureRoute";
export var SecureRoute = deprecateComponent(SecureRouteInternal, {
  deprecated: "SecureRoute from @jutro/auth",
  alternative: "SecureRoute from @jutro/router"
});
SecureRouteInternal.__docgenInfo = {
  description: "Route which requires authentication\n\n@type {React.FC<PropTypes.InferProps<typeof secureRoutePropTypes>>}",
  methods: [],
  displayName: "SecureRoute",
  props: {
    children: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Functions called when rendering route. Takes precedence over component and render\n({ auth: Auth, ...routeProps }) => React.ReactNode"
    },
    component: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "Component to be render when authenticated. Takes precedence over render"
    },
    render: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Functions called when rendering route\n({ auth: Auth, ...routeProps }) => React.ReactNode"
    }
  }
}, SecureRouteInternal.__docgenInfo = {
  componentName: "SecureRoute",
  packageName: "@jutro/auth",
  description: "Route which requires authentication",
  displayName: "SecureRoute",
  methods: [],
  actualName: "SecureRouteInternal",
  props: {
    children: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Functions called when rendering route. Takes precedence over component and render\n({ auth: Auth, ...routeProps }) => React.ReactNode"
    },
    component: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "Component to be render when authenticated. Takes precedence over render"
    },
    render: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Functions called when rendering route\n({ auth: Auth, ...routeProps }) => React.ReactNode"
    }
  }
};